/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type authActions = {
    readonly verifiedTradeStatus: string | null;
    readonly " $refType": "authActions";
};
export type authActions$data = authActions;
export type authActions$key = {
    readonly " $data"?: authActions$data;
    readonly " $fragmentRefs": FragmentRefs<"authActions">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authActions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verifiedTradeStatus",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '0e159f1d52d8df9f6a0dceae69d2b609';
export default node;
